import React, {useEffect, useState} from 'react'
import {inject, observer} from 'mobx-react'
import {getMediaWallProgram, getNodePositionList, getMonitorList, getMediaWallList} from '@apis'
import MonitorItem from '@components/monitorItem'
import mediaIcon from '@assets/img/node.png'
import monitorIcon from '@assets/img/monitor.png'
import electronicIcon from '@assets/img/electric.png'

const IndexChart = inject('store')(
  observer(({store}) => {
    const {userInfo = {}} = store
    const {brokerId} = userInfo

    const [buildingList, setBuildingList] = useState([])
    const [programList, setProgramList] = useState([])
    const [nodeList, setNodeList] = useState([])
    const [monitorList, setMonitorList] = useState([])
    const [nodeName, setNodeName] = useState()
    const [onlineStatus, setOnlineStatus] = useState("不在线")
    const [playStatus, setPlayStatus] = useState("未播放")
    const [isOver, setIsover] = useState(0)
    const [monitorUrl, setMonitorUrl] = useState()
    const [monitorToken, setMonitorToken] = useState()

    // 查询楼宇列表
    async function queryBuildList() {
      const params = {
        pageNo: 1,
        pageSize: 9999,
        brokerId
      }
      const res = await getMediaWallProgram(params)
      if (res && res.data) {
        setProgramList(res.data)
      }
    }

    // 查询节点列表
    async function queryNodeList() {
      const params = {
        pageNo: 1,
        pageSize: 9999,
        brokerId
      }
      const res = await getMediaWallList(params)
      if (res && res.data) {
        setNodeList(res.data)
      }
    }

    // 查询监控列表
    async function queryMonitorList() {
      const params = {
        pageNo: 1,
        pageSize: 9999,
        brokerId
      }
      const res = await getMonitorList(params)
      if (res && res.data) {
        setMonitorList(res.data)
      }
    }

    // 查询所有节点的位置信息
    async function queryNodePositionList() {
      const params = {
        brokerId,
      }
      const res = await getNodePositionList(params)
      console.log('res--', res)
      if (res) {
        let buildList = []
        if (res.mediaLocationList) {
          buildList = buildList.concat(res.mediaLocationList.map(item => ({
            type: 'media',
            location: item,
          })))
        }
        if (res.monitorLocationList) {
          buildList = buildList.concat(res.monitorLocationList.map(item => ({
            type: 'monitor',
            location: item,
          })))
        }
        if (res.strongCurrentLocationList) {
          buildList = buildList.concat(res.strongCurrentLocationList.map(item => ({
            type: 'electronic',
            location: item,
          })))
        }
        setBuildingList(buildList)
        // console.log('buildList--', buildList)
      }
    }

    function initChart() {
      if (!buildingList.length) return

      const dataList = buildingList.map(item => {
        try {
          if(item.type == 'electronic') {
            const location = JSON.parse(item.location)
            const result = {
              location: location.location,
              type: item.type,
            }
            return result
          } else {
            const location = JSON.parse(item.location.location)
            const result = {
              location: location.location,
              type: item.type,
            }
            return result
          }
        } catch (e) {
          console.log('解析位置信息失败')
        }
      })

      const map = new AMap.Map('map_container', {
        pitch: 66,
        center: dataList[0].location,
        zoom: 20,
        mapStyle: 'amap://styles/fresh', //darkblue
        viewMode: '3D',
      });
  
      // const testData = [
      //   {
      //     location: [
      //       120.670786,
      //       30.512175
      //     ]
      //   }
      // ]

      map.on('click', function(e) {
        setIsover(0)
        for(let i=0; i<dataList.length; i++) {
          if(dataList[i].location[0]-0.0006 <= e.lnglat.getLng() && e.lnglat.getLng() <= dataList[i].location[0]-0.0003) {
            if(dataList[i].location[1]+0.0007 <= e.lnglat.getLat() &&  e.lnglat.getLat()<= dataList[i].location[1]+0.001) {
              if(buildingList[i].type == "media") {
                setIsover("media")
                for(let x=0; x<programList.length; x++) {
                  if(programList[x].playStatus == 1) {
                    for(let j=0; j<programList[x].programBillMediaWallInstanceDTOList.length; j++) {
                      if(programList[x].programBillMediaWallInstanceDTOList[j].onlineStatus == 1) {
                        setPlayStatus("播放中")
                      }
                    }
                  }
                  for(let j=0; j<nodeList.length; j++) {
                    if(nodeList[j].id == buildingList[i].location.mediaWallId) {
                      setNodeName(nodeList[j].name)
                      if(nodeList[j].onlineStatus == 1) {
                        setOnlineStatus("在线")
                      }
                    }
                  }
                }
              }
              if(buildingList[i].type == "monitor") {
                setIsover("monitor")
                for(let n=0; n<monitorList.length; n++) {
                  if(buildingList[i].location.monitorId == monitorList[n].id) {
                    setMonitorUrl(monitorList[n].url)
                    setMonitorToken(monitorList[n].monitorAccessToken)
                  }
                }
              }
            }
          }
        }
      });
      const vl = new Loca.IconLayer({
        map: map
      });
  
      vl.setData(dataList, {
        lnglat: 'location'
      });
  
      vl.setOptions({
        source: function(res) {
          // console.log('res--', res)
          // console.log('res.value.type--', res.value.type)
          if (res.value.type === 'media') {
            return mediaIcon
          }
          if (res.value.type === 'monitor') {
            return monitorIcon
          }
          if (res.value.type === 'electronic') {
            return electronicIcon
          }
          return mediaIcon
        },
        style: {
          size: 30
        }
      });
  
      vl.render();
    }
  
    useEffect(() => {
      queryBuildList()
      queryNodeList()
      queryMonitorList()
      queryNodePositionList()
      // initChart()
    }, [])

    useEffect(() => {
      initChart()
    }, [buildingList, programList, monitorList, nodeList])
  
    return (
      <div>
        <div className="ck-index-left" id="map_container" style={{height: '100%'}}/>
        {isOver == 0 ? null :
          (isOver == "media" ?(<div style={{backgroundColor: 'rgb(101 220 245)', position: 'relative', fontSize: '20px',bottom: '933px', left: '655px', padding: '15px', width: '32%'}}>
            <div>节点名称：{nodeName}</div>
            <div style={{padding: '15px 0 15px 0'}}>在线状态：{onlineStatus}</div>
            <div>播放状态：{playStatus}</div>
          </div>) :
            (<div className="monitorurl">
              <MonitorItem
                url={monitorUrl}
                accessToken={monitorToken}
              />
            </div>)
          )  
        }
      </div>
    )
  })
)

export default IndexChart
